import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import Calendar from "react-calendar";

import "react-calendar/dist/Calendar.css";
import "./Calendar.css";

import styles from "./Calendar.module.css";

function CalendarComp({ markedDate, getLoanData }) {
  const [value, setValue] = useState(new Date());

  function onChange(nextValue) {
    setValue(nextValue);
  }

  const eventsData = markedDate?.map((data) => {
    return {
      start: moment(data).format("YYYY-MM-DD"),
      end: data,
    };
  });

  const tileContent = ({ date, view }) => {
    // Add class to tiles in month view only
    if (view === "month") {
      // Check if a date React-Calendar wants to check is on the list of dates to add class to
      if (
        eventsData?.find(
          (dDate) => dDate?.start == moment(date).format("YYYY-MM-DD")
        )
      ) {
        return (
          <div className={styles.eventCont}>
            <div className={styles.activeDate} />
          </div>
        );
      } else {
        return (
          <div className={styles.eventCont}>
            <div className={styles.inactiveDate} />
          </div>
        );
      }
    }
  };
  return (
    <Calendar
      onChange={onChange}
      value={value}
      tileContent={tileContent}
      onClickDay={getLoanData}
      next2Label={null}
      prev2Label={null}
    />
  );
}

export default CalendarComp;
